import React from 'react';
import iconUser from '../assets/img/man.png'; // pastikan ada icon user di path ini
import pemkot from '../assets/img/logo.png'; // logo pemkot di path ini
import { useStateAuthContext, useStateHostContext } from '../context';
import { useNavigate } from 'react-router-dom';
import { error } from '../notify';
import ManualBook from '../assets/doc/manual_book.pdf'

const Login = () => {
  window.document.title = "Login System"
  const direct = useNavigate()

  const { DISPATCH_AUTH } = useStateAuthContext();
  const { HOST } = useStateHostContext();

  const [user, setUser] = React.useState('')
  const [pass, setPass] = React.useState('')
  const [isError, setError] = React.useState(false)
  const [isLoading, setLoading] = React.useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError(false)

    const param = new FormData()
    param.append("username", user)
    param.append("password", pass)

    const requ = await fetch(`${HOST}/auth/login`, { method: 'POST', body: param })
    try {
      const resu = await requ.json()
      if (resu.s) {
        if (resu.d.is_aktif) {
          const SET_DISPATCH = { type: 'LOGIN', payload: resu.d }
          DISPATCH_AUTH(SET_DISPATCH)
          direct(resu.d.is_super_admin || resu.d.is_admin ? "/admin" : "/opd")
        } else {
          error({ msg: 'Status akun tidak aktif' })
        }
      } else {
        error({ msg: resu.m })
      }
      setLoading(false)
    } catch (err) {
      error({ msg: err.message })
      setError(true)
      setLoading(false)
    }
  }

  return (
    <main style={style.wrapper}>
      <div className="container-fluid d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="row w-100 justify-content-center">
          <div className="col-lg-6 col-md-10">
            <div className="row bg-white shadow-lg rounded-3 overflow-hidden">

              {/* SISI KIRI */}
              <div className="col-md-6 p-4 d-flex flex-column justify-content-center align-items-center bg-light">
                <img src={iconUser} alt="User Icon" width="120" className="mb-3" />
                <h4 className="mb-4">Login Sistem</h4>
                <form onSubmit={handleSubmit} className="w-100 px-3">
                  <div className="form-floating mb-3">
                    <input className="form-control" name="username" type="text" autoComplete="off" value={user} onChange={e => setUser(e.target.value)} required />
                    <label htmlFor="inputUsername">Nama Pengguna</label>
                  </div>
                  <div className="form-floating mb-3">
                    <input className="form-control" name="password" type="password" autoComplete="off" value={pass} onChange={e => setPass(e.target.value)} required />
                    <label htmlFor="inputPassword">Kata Sandi</label>
                  </div>
                  <div className="d-grid gap-2 mb-2">
                    {isLoading ? (
                      <button className="btn btn-success" type="button" disabled>
                        <span className="spinner-border spinner-border-sm"></span> Mohon tunggu...
                      </button>
                    ) : (
                      <button className="btn btn-success" type="submit">Masuk</button>
                    )}
                    {isError && (
                      <div className="alert alert-danger text-center">Tidak bisa login! Terjadi kesalahan sistem.</div>
                    )}
                  </div>
                  <div className="text-center">
                    <a href={ManualBook} download className="btn btn-outline-secondary w-100 btn-sm">
                      📘 Unduh Manual Book
                    </a>
                  </div>
                </form>
              </div>

              {/* SISI KANAN */}
              <div className="col-md-6 p-4 d-none d-md-flex flex-column justify-content-center align-items-center text-center bg-white">
                <img src={pemkot} alt="Logo Pemkot" width="80" className="mb-3" />
                <h3 className="text-success">SiKENDIS</h3>
                <p className="mb-0">(Sistem Informasi Kendaraan Dinas)</p>
                <small className="text-muted mb-4">Versi system 2.2.1</small>
                <p style={{ fontSize: '12px' }}>
                  © 2023 - Badan Pengelola Keuangan Daerah <br />
                  Pemerintah Kota Kotamobagu
                </p>
              </div>

              {/* FOOTER MOBILE */}
              <div className="col-12 d-md-none text-center py-2" style={{ background: '#f8f9fa', fontSize: '11px' }}>
                <strong>SiKENDIS</strong> &copy; 2023 - BPKD Kota Kotamobagu
              </div>

            </div>
          </div>
        </div>
      </div>
    </main>

  );
}

const style = {
  wrapper: {
    minHeight: '100vh',
    backgroundImage: `url(${require('../assets/img/bg.jpg')})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
  }
}

export default Login;
